import type { OperationVariables } from '@apollo/client'
import { useSubscription as useBaseSubscription } from '@apollo/client/react/compiled'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

export type UseSubscriptionResult<TData> = useBaseSubscription.Result<TData>

type UseSubscriptionOpts<
  TData,
  TVariables extends OperationVariables,
> = useBaseSubscription.Options<NoInfer<TData>, NoInfer<TVariables>>

export function useSubscription<TData, TVariables extends OperationVariables>(
  document: TypedDocumentNode<TData, TVariables>,
  opts: UseSubscriptionOpts<TData, TVariables>,
): UseSubscriptionResult<TData> {
  return useBaseSubscription<TData, TVariables>(document, opts) as UseSubscriptionResult<TData>
}
